<template>
	<transition name="slide-fade">
		<v-container fluid>
			<v-layout wrap>
				<v-flex xs12>
					<h3 class="text-center">Dashboard</h3>
				</v-flex>
			</v-layout>
			<v-layout wrap class="justify-end">
				<v-flex xs12 sm6 md6 order-md1 order-sm3 order-xs4 v-if="can['clients.index']" class="pa-1" id="latest-clients">
					<v-card>
						<v-card-title class="py-0 pl-0 primary" @click="viewClients = !viewClients">
							<v-icon large>mdi-chevron-double-down {{ viewClients ? 'mdi-flip-v' : '' }}</v-icon>
							<v-spacer></v-spacer>
							Latest Clients
						</v-card-title>
						<v-card-text v-show="viewClients">
							<v-skeleton-loader type="table-row@3" v-show="loading"></v-skeleton-loader>
							<show-clients :clients="clients" v-show="!loading"></show-clients>
						</v-card-text>
					</v-card>
				</v-flex>
				<v-flex xs12 sm6 md6 order-md3 order-sm2 order-xs3 v-if="can['professionals.index']" class="pa-1" id="inactive-professionals">
					<v-card>
						<v-card-title class="py-0 pl-0 primary" @click="viewPros = !viewPros">
							<v-icon large>mdi-chevron-double-down {{ viewPros ? 'mdi-flip-v' : '' }}</v-icon>
							<v-spacer></v-spacer>
							Professionals Not Activated ({{ professionals.length }})
						</v-card-title>
						<v-card-text v-show="viewPros">
							<v-skeleton-loader type="table-row@3" v-show="loading"></v-skeleton-loader>
							<show-professionals :professionals="professionals" v-show="!loading"></show-professionals>
						</v-card-text>
					</v-card>
				</v-flex>
				<v-flex xs12 sm6 md6 order-md2 order-sm1 order-xs2 v-if="can['service_requests.index']" class="pa-1" id="unclaimed-requests">
					<v-card>
						<v-card-title class="py-0 pl-0 primary">
							<v-spacer></v-spacer>
							UnClaimed Requests
						</v-card-title>
						<v-card-text>
							<div v-show="loading">
								<v-skeleton-loader type="table-row@3"></v-skeleton-loader>
							</div>
							<show-request :service_requests="service_requests" v-show="!loading"></show-request>
						</v-card-text>
						<v-card-actions class="py-0" :class="confirmations && confirmations > 0 ? 'error' : 'success'" role="button" @click="goTo('/service_request_confirmations')" v-show="confirmations !== null">
							<p class="my-0">
								<u>
									<b>Pending Admin Confirmations:</b> {{ confirmations}}
								</u>
							</p>
						</v-card-actions>
					</v-card>
				</v-flex>
				<v-flex xs12 sm6 md6 order-md4 order-sm4 order-xs1 v-if="can['invoices.index']" class="pa-1" id="unpaid-invoices">
					<v-card>
						<v-card-title @click="viewInv = !viewInv" class="py-0 pl-0 primary">
							<v-icon large>mdi-chevron-double-down {{ viewInv ? 'mdi-flip-v' : '' }}</v-icon>
							<v-spacer></v-spacer>
							Unpaid & Processing Invoices
						</v-card-title>
						<v-card-text v-show="viewInv">
							<v-skeleton-loader type="table-row@3" v-show="loading"></v-skeleton-loader>
							<view-invoices :invoices="invoices" v-show="!loading"></view-invoices>
						</v-card-text>
					</v-card>
				</v-flex>
			</v-layout>
		</v-container>
	</transition>
</template>

<script>
	import layout from '@/Layouts/MainLayout'
	const ShowClients = async () => await import( /* webpackMode: 'lazy' */ /* webpackChunkName: "clients" */ '@/Components/Clients/index')
	const ShowProfessionals = async () => await import( /* webpackMode: 'lazy' */ /* webpackChunkName: "professionals" */ '@/Components/Professionals/professionals')
	const ShowRequest = async () => await import( /* webpackMode: 'lazy' */ /* webpackChunkName: "service-requests" */ '@/Components/ServiceRequest/index')
	const ViewInvoices = async () => await import( /* webpackMode: 'lazy' */ /* webpackChunkName: "invoices" */ '@/Components/Invoices/invoices')

	export default {
		name: 'Dashboard',
		layout,
		props: {
			professionals: {
				default: () => []
			},
			service_requests: {
				default: () => []
			},
			clients: {
				default: () => []
			},
			invoices: {
				default: () => []
			},
			confirmations: {
				default: () => null
			},
		},
		components: {
			ShowClients,
			ShowProfessionals,
			ShowRequest,
			ViewInvoices,
		},
		metaInfo () {
			return {
				title: 'Dashboard',
				titleTemplate: '%s | ' + this.$title,
			}
		},
		data () {
			return {
				viewClients: false,
				viewPros: false,
				viewInv: false,
				loading: true,
			}
		},
		methods: {
			getData: _.debounce(function () {
				this.$inertia.visit('/dashboard', {
					only: ['professionals', 'service_requests', 'clients', 'invoices'],
					onBefore: () => {
						this.loading = true
					},
					onFinish: () => {
						this.loading = false
					},
					preserveState: true,
					preserveScroll: true,
				})
			}, 2000)
		},
		mounted () {
			this.loading = false
			this.$nextTick(() => {
				this.getData()
			})
		},
		watch: {
			'clients': function (newvalue, oldvalue) {
				if (oldvalue.length > 1 && newvalue.length == 0) {
					this.getData()
				}
			},
			'invoices': function (newvalue, oldvalue) {
				if (oldvalue.length > 1 && newvalue.length == 0) {
					this.getData()
				}
			},
			'professionals': function (newvalue, oldvalue) {
				if (oldvalue.length > 1 && newvalue.length == 0) {
					this.getData()
				}
			},
			'service_requests': function (newvalue, oldvalue) {
				if (oldvalue.length > 1 && newvalue.length == 0) {
					this.getData()
				}
			}
		}
	}
</script>
